export default {
  name: 'kk',
  el: {
    breadcrumb: {
      label: 'Breadcrumb', // to be translated
    },
    colorpicker: {
      confirm: 'Қабылдау',
      clear: 'Тазалау',
    },
    datepicker: {
      now: 'Қазір',
      today: 'Бүгін',
      cancel: 'Болдырмау',
      clear: 'Тазалау',
      confirm: 'Қабылдау',
      selectDate: 'Күнді таңдаңыз',
      selectTime: 'Сағатты таңдаңыз',
      startDate: 'Басталу күні',
      startTime: 'Басталу сағаты',
      endDate: 'Аяқталу күні',
      endTime: 'Аяқталу сағаты',
      prevYear: 'Алдыңғы жыл',
      nextYear: 'Келесі жыл',
      prevMonth: 'Алдыңғы ай',
      nextMonth: 'Келесі ай',
      year: 'Жыл',
      month1: 'Қаңтар',
      month2: 'Ақпан',
      month3: 'Наурыз',
      month4: 'Сәуір',
      month5: 'Мамыр',
      month6: 'Маусым',
      month7: 'Шілде',
      month8: 'Тамыз',
      month9: 'Қыркүйек',
      month10: 'Қазан',
      month11: 'Қараша',
      month12: 'Желтоқсан',
      week: 'Апта',
      weeks: {
        sun: 'Жек',
        mon: 'Дүй',
        tue: 'Сей',
        wed: 'Сәр',
        thu: 'Бей',
        fri: 'Жұм',
        sat: 'Сен',
      },
      months: {
        jan: 'Қаң',
        feb: 'Ақп',
        mar: 'Нау',
        apr: 'Сәу',
        may: 'Мам',
        jun: 'Мау',
        jul: 'Шіл',
        aug: 'Там',
        sep: 'Қыр',
        oct: 'Қаз',
        nov: 'Қар',
        dec: 'Жел',
      },
    },
    select: {
      loading: 'Жүктелуде',
      noMatch: 'Сәйкес деректер жоқ',
      noData: 'Деректер жоқ',
      placeholder: 'Таңдаңыз',
    },
    mention: {
      loading: 'Жүктелуде',
    },
    cascader: {
      noMatch: 'Сәйкес деректер жоқ',
      loading: 'Жүктелуде',
      placeholder: 'Таңдаңыз',
      noData: 'Деректер жоқ',
    },
    pagination: {
      goto: 'Бару',
      pagesize: '/page',
      total: 'Барлығы {total}',
      pageClassifier: '',
      page: 'Page', // to be translated
      prev: 'Go to previous page', // to be translated
      next: 'Go to next page', // to be translated
      currentPage: 'page {pager}', // to be translated
      prevPages: 'Previous {pager} pages', // to be translated
      nextPages: 'Next {pager} pages', // to be translated
    },
    messagebox: {
      title: 'Хабар',
      confirm: 'Қабылдау',
      cancel: 'Болдырмау',
      error: 'Жарамсыз енгізулер',
    },
    upload: {
      deleteTip: 'Өшіруді басып өшіріңіз',
      delete: 'Өшіру',
      preview: 'Алдын ала қарау',
      continue: 'Жалғастыру',
    },
    table: {
      emptyText: 'Деректер жоқ',
      confirmFilter: 'Қабылдау',
      resetFilter: 'Қалпына келтіру',
      clearFilter: 'Барлығы',
      sumText: 'Сомасы',
    },
    tree: {
      emptyText: 'Деректер жоқ',
    },
    transfer: {
      noMatch: 'Сәйкес деректер жоқ',
      noData: 'Деректер жоқ',
      titles: ['List 1', 'List 2'],
      filterPlaceholder: 'Кілт сөзді енгізіңіз',
      noCheckedFormat: '{total} элэмэнт',
      hasCheckedFormat: '{checked}/{total} құсбелгісі қойылды',
    },
    image: {
      error: 'FAILED', // to be translated
    },
    pageHeader: {
      title: 'Back', // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Yes', // to be translated
      cancelButtonText: 'No', // to be translated
    },
    carousel: {
      leftArrow: 'Carousel arrow left', // to be translated
      rightArrow: 'Carousel arrow right', // to be translated
      indicator: 'Carousel switch to index {index}', // to be translated
    },
  },
}
